<template>
  <div class="homepage">

    <div class="total-box">
      <div class="toptitle fsc">
        <img class="toptitle-img" src="@/assets/logo.png" alt="" />
        <div class="loginbox lginbgss fcc" v-if="!$store.state.usuerdata.token" @click="login">
          登录
        </div>
        <div class="loginbox fcc nobgsed" v-else @click="login">
          姓名：{{
            $store.state.usuerdata.name ? $store.state.usuerdata.name : "无"
          }}
        </div>
        <div class="loginbox lginbgss fcc" v-if="$store.state.usuerdata.token" @click="exit">
          退出登录
        </div>
        <div class="loginbox fcc nobgsed peops" @click="login">
          访客人数：{{ peonums }}
        </div>
      </div>
      <div class="top-select-box">
        <div class="ts-left">
          <div class="leftdata-box">
            <!-- <div class="lfs-one fcc">
              首页
            </div> -->
            <div class="items-box">
              <div class="item-morebox" v-for="(item, index) in list" :key="index" @click="tonextss(item, index)">
                <div class="item-ins">
                  <img v-show="item.isactive" class="showimg" src="@/assets/show.png" alt="" />
                  {{ item.name }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ts-right">
          <video width="100%" ref="videoRef" height="100%" controls v-show="acindex == 1 && !isPdf">
            <source src="/static/home.mp4" type="video/mp4">
            </source>
          </video>
          <video width="100%" ref="videoReftwo" height="100%" controls v-show="acindex == 2 && !isPdf">
            <source src="/static/hometwo.mp4" type="video/mp4">
            </source>
          </video>

          <div class=" pdtop" v-show="isPdf">
            <div class="titles-infos-news fs">
              <!-- <div class="" v-for="(item, index) in docList" :key="index">
                <el-button @click="openDoc(item)">{{ item.name }}</el-button>
              </div> -->
              <div class="level-2" >
                  <div class="item" v-for="(item, index) in docList" :key="index" @click="level2ActiceChange(index)">
                    <span class="name">
                      {{ item.name }}
                    </span>
                    <img src="@/assets/le-2-item.png" class="bg" alt="">
                    <img src="@/assets/le-2-active.png" v-if="level2ActiceIndex == index" class="ac" alt="">
                  </div>
              </div>
              <div class="level-2"  v-if="level2ActiceIndex != 1">
                <div class="item" @click="openDoc(item)" v-for="(item, index) in docList[level2ActiceIndex].children" :key="index">
                    <div class="name" >
                      {{item.fileName}}
                    </div>
                    <img src="@/assets/le-3-item.png"  class="bg-3"  alt="">
                    <img src="@/assets/le-3-active.png" class="ac" alt="">
                  </div>
              </div>
              <div class="level-2-name" v-else>
                <div class="item" @click="openDoc(item)"  v-for="(item, index) in docList[level2ActiceIndex].children" :key="index">
                    <div class="name" >
                      {{item.fileName}}
                    </div>
                    <img src="@/assets/le-3-active.png" class="ac" alt="">
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="infosbox" v-show="acindex == 2">
        <div class="titles-infos fcc">
          <div class="items-infos fcc" @click="acitemindex = 1" :class="{ acitemindex: acitemindex == 1 }">
            实验简介
            <img v-if="acitemindex == 1" class="bottomac" src="@/assets/bottomac.png" alt="" />
            <img class="linetwo" src="@/assets/linetwo.png" alt="" />
          </div>
          <div class="items-infos fcc" @click="acitemindex = 2" :class="{ acitemindex: acitemindex == 2 }">
            实验教学目标
            <img v-if="acitemindex == 2" class="bottomac" src="@/assets/bottomac.png" alt="" />
            <img class="linetwo" src="@/assets/linetwo.png" alt="" />
          </div>
          <div class="items-infos fcc" @click="acitemindex = 3" :class="{ acitemindex: acitemindex == 3 }">
            实验原理
            <img v-if="acitemindex == 3" class="bottomac" src="@/assets/bottomac.png" alt="" />
            <!-- <img class="linetwo" src="@/assets/linetwo.png" alt="" /> -->
          </div>
          <!-- <div class="items-infos fcc" @click="acitemindex = 4" :class="{ acitemindex: acitemindex == 4 }">
            实验内容
            <img v-if="acitemindex == 4" class="bottomac" src="@/assets/bottomac.png" alt="" />
          </div> -->
        </div>
        <div class="main-info" v-html="jsinfo[acitemindex]">
        </div>
        <!-- <div class="fcc">
          <img class="main-imginfo" src="" alt="" />
        </div> -->
      </div>

      <div v-if="acindex == 1">
        <div class="center-bg">
          <div class="centers">
            <div class="ct-title fcc">课程团队</div>
            <div class="myswipers">
              <div class="swiper-container">
                <div class="swiper-wrapper">
                  <div class="swiper-slide fcc" v-for="(item, index) in teacherlist">
                    <div class="fcc sw-boxs-bg">
                      <div class="sw-boxs">
                        <div class="sw-top fac">
                          <div class="swt-left">
                            <img :src="item.url" alt="">
                          </div>
                          <div class="swt-right fnccc">
                            <span>{{ item.name }}</span>
                            <!-- <span>英语老师</span> -->
                          </div>
                        </div>
                        <div class="sw-bottom">
                          <marquee>
                            介绍：{{ item.des }}
                          </marquee>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="prev" @click="back"></div>
              <div class="next" @click="next"></div>
            </div>
          </div>
        </div>
        <div class="centers-two">
          <div class="ct-title-two fcc">探索介绍</div>
          <div class="bottomallbox fcc">
            <div class="babss-left fbc">
              <img class="lineimg-bos" src="@/assets/line.png" alt="" />
              <div class="bllft fac fdcc">
                <span class="title">实验须知</span>
                <div class="fsc">
                  浏览器需求: Chrome最新版 或浏览器内核webkit69， 火狐浏览器
                </div>

              </div>
              <div class="blright fac fdcc">
                <span class="title">知识产权</span>
                <div class="fsc">
                  软件著作登记号：2022SR0534629
                  <el-image class="imgsbss" :src="require('@/assets/zscq.png')"
                    :preview-src-list="[require('@/assets/zscq.png')]">
                  </el-image>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottomnews ">
        <div class="fccolumn">
          <span>主办单位：{{ other.organizer }}</span>
          <span>技术支持：{{ other.technicalSupport }}</span>
        </div>
        <!-- <div class="fccolumn qq">
          <span>{{ other.qqTxt }}</span>
          <span>qq群：{{ other.qq }}</span>
        </div>
        <el-image class="evm" :preview-src-list="[require('@/assets/evm.png')]" :src="require('@/assets/evm.png')">
        </el-image> -->

      </div>
      <el-tooltip class="item" effect="dark" content="鲁迅文化足迹虚拟仿真实验支持和服务" placement="top-start">
        <img class="qqqun" @click="toqq" src="@/assets/qqqun.png" alt="">
      </el-tooltip>

    </div>
  </div>
</template>
<script>
// 导入组件
import { proNum } from "@/api/userMG";
import Swiper from "swiper";
import "swiper/swiper.min.css";
import "swiper/swiper-bundle.css";
import setRemInit from "@/utils/px2rem"; ///rem
import marqueemy from "@/components/marqueemy.vue";
setRemInit();
export default {
  name: "index",
  components: {
    marqueemy,
  },
  data() {
    return {
      level2ActiceIndex: 0,
      levelKey: "",
      teacherlist: [
        {
          name: "陈蘅瑾",
          url: require("@/assets/cxj.jpg"),
          des: "教授、博士，硕士生导师，浙江省高校优秀教师，美国纽约大学访问学者，主要从事现当代文学教学与研究。",
        },
        {
          name: "古大勇",
          url: require("@/assets/gdy.jpg"),
          des: "教授、博士，硕士生导师，省高等学校新世纪优秀人才，市哲社领军人才，主要从事现当代文学教学与研究。",
        },
        {
          name: "卓光平",
          url: require("@/assets/zgy.jpg"),
          des: "副教授、博士，硕士生导师，绍兴市首届“社科新人”，浙江省“之江青年社科学者”，主要从事现当代文学教学与研究。",
        },
        {
          name: "李红霞",
          url: require("@/assets/lhx.jpg"),
          des: "副教授、博士，硕士生导师，浙江省“之江青年社科学者”，主要从事中国现当代文学教学与研究。",
        },
        {
          name: "王传习",
          url: require("@/assets/wcx.jpg"),
          des: "讲师、博士，绍兴市“社科新人”，主要从事中国现当代文学教学与研究。",
        },
      ],
      acindex: 1,
      peonums: 0,
      acitemindex: 1,
      list: [
        // { name: "班级管理", isactive: true },
        { name: "项目概况", isactive: true },
        { name: "项目介绍", isactive: false },
        { name: "学习资料", isactive: false },
        {
          name: "开始探索",
          isactive: false,
          path: "unity",
        },
        { name: "用户中心", isactive: false, path: "/my/infos" },
      ],
      swiperData: {},
      jsinfo: {
        1: `<p>鲁迅文化足迹虚拟仿真实验立足中国现代文学、鲁迅研究、地域文学与家国情怀等课程，以鲁迅足迹为时空轴，探寻鲁迅一生情感思想发展过程的虚拟仿真实验。鲁迅从绍兴出发，一生足迹遍布南京、日本、杭州、北京、厦门、广州和上海等地，鲁迅或求学、或工作、或战斗，“立人”的执着贯穿他的一生，并在其文学世界中化作系列经典人物形象。无论是中学教材中鲁迅文本的争论、网络中最常被调用、解构与再造的鲁迅还是大学中文类专业学生对鲁迅思想深度的难以理解，主要症结在于如何回到历史语境中理解鲁迅情感与思想的形成，这也正是中国现代文学课程中鲁迅专题教学的难点所在。由此，中文专业的学生经常由专业老师带队，利用假期到绍兴等地开展实地研学，以期通过理论教学与实践研习相结合，取得较好的教学效果。然而，由于受各利因素的制约，实地研学很难全面展开，受益的学生少之又少。鲁迅文化足迹虚拟仿真实验即针对这一教学难点进行设计，本实验是以虚拟仿真技术再现鲁迅在故乡百草园和三味书屋、南京矿路学堂、日本仙台医专和东京伍舍、北京绍兴会馆和西三条21号以及上海大陆新村的生活、学习和工作的场景，在虚拟的历史场景中，通过互动与游戏等方式，使学生沉浸于时空现场，帮助学生全面理解鲁迅思想形成的综合性学习与训练。</p>`,
        2: `<p>	鲁迅是中国现代文学的开端，也是中国现代文学的高峰，其以开端即为高峰的创作活动，在小说、散文和杂文等领域在中国现代文学产生了广泛而深远的影响，引领中国现当代文学的发展。鲁迅“立人”思想和民族魂精神对个人、民族和国家产生了深远的影响，其辐射范围之广影响之深刻，亦是少有并行者。同时，鲁迅的人格及其融于文字中的对个人、民族、国家和人类的情感，点燃了一代代中外学人的学术热情和生命激情，也成为中外文化交流的重要纽带和桥梁。随着时代的变迁，不少大学生无法理解鲁迅先生作品中的思想与情感，不利于鲁迅精神的弘扬。通过本虚拟仿真实验，应达到的教学目标如下：
          <p>1.知识目标： 通过虚拟鲁迅在绍兴、南京、日本、北京、上海等场景中的交互性实验操作，使学生在虚拟的场景中体验鲁迅不同人生阶段的生活、学习与思想经历，掌握《呐喊·自序》《从百草园到三味书屋》《琐记》《阿长与<山海经>》《藤野先生》《野草》等文本中的相关细节，并通过对其阅读书籍的归类整理，对鲁迅的知识结构、艺术修养有全面立体的了解，理解进化论、存在主义、马克思主义思想等在鲁迅思想形成过程中的影响。</p>
          <p>2.能力目标：通过虚拟情境设置，进一步提高学生文本细读的能力，培养学生的不同情境中的情感感知力；通过鲁迅人生主要阶段的虚拟仿真实验，培养学生在整体视野中不同阶段文化接受与思想影响的问题意识与思考能力，激发并培养学生的对问题的深入探究的能力。</p>
          <p>3.素养目标：通过虚拟情境体验，提高学生对鲁迅不同人生阶段的学习和人生选择的更直观的感知力，强化学生人文情怀的培养。</p>
          <p>4.价值目标：通过鲁迅弃医从文选择、绍兴会馆的寂寞与痛苦以及上海时期对年轻人的培养，感知鲁迅的家国情怀，进一步走近作家鲁迅、学者鲁迅、美术设计大师鲁迅和“民族魂”鲁迅，做优课程思政。
</p>`,
        3: `<p>	本项目旨在解决鲁迅专题教学中时空不可追及、情境不可再现、思想难以理解等问题，利用虚拟仿真可创建和体验虚拟世界的优势，借助视觉、听觉等多种传感通道，积极能动地操作虚拟现实，使学生沉浸在仿真的情境中，进行自然的交互和体验，通过沉浸、构想到交互不同层级的感知力，更好地理解历史语境下鲁迅的情感与思想，并激发学生在现实世界中进一步探究鲁迅思想的欲望。</p><p>	1.情景再现重要人生历程。</p><p>	以虚拟仿真的形式再现鲁迅人生中绍兴、南京、东京、仙台、北京、上海等重要的人生阶段，将鲁迅百草园的童趣、南京新学与新思想的接受、仙台弃医从文、东京的文学救国梦、北京绍兴县馆孤独中思想的沉淀以及上海理性战斗等情景进行再现，学生身临其境感受鲁迅人生不同阶段的文化选择。</p><p>	2.仿真技术沉浸历史文化空间。</p><p>	3D呈现百草园、三味书屋、仙台医专教室、东京伍舍、北京绍兴县馆、西三条“老虎尾巴”和上海大陆新村鲁迅故居等鲁迅曾学习生活的历史文化空间，利用虚拟仿真技术，以沉浸式、交互性与创造性的形式展现历史文物和历史场景，让学生在历史文化场域中零距离感受鲁迅的文化选择。</p><p>	3.交互体验中激发学习热情。</p><p>	以和鲁迅对话交流、游戏以及完成相应任务为主要通关内容，在玩中学、在对话中萌发新的思想，并通过设置相关题目来检验学生学习效果，激发学生的学习积极性。</p>`,
      },
      docList: [
      {
          name: "课件（演示文稿)",
          children: [
            {
              fileName: "1.鲁迅《狂人日记》",
              path: 'https://lxwhfz.usx.edu.cn/5f6763a9c3326029edd0b4d6777564a7.pdf',
            },
            {
              fileName: "2.鲁迅《阿Q正传》",
              path: 'https://lxwhfz.usx.edu.cn/acd39a2fb12a1db889e7bbc71eb031c6.pdf',
            },
            {
              fileName: "3.鲁迅《故事新编》",
              path: 'https://lxwhfz.usx.edu.cn/2117494817fbacbf18246e5ad46a2800.pdf',
            },
            {
              fileName: "4.鲁迅《朝花夕拾》《野草》",
              path: 'https://lxwhfz.usx.edu.cn/9d4f9cdbfcd9c5a6fa1928284341ebbd.pdf',
            },
            {
              fileName: "5.鲁迅杂文",
              path: 'https://lxwhfz.usx.edu.cn/9c4852245313f14dfe480c9aeff68b2e.pdf',
            },
          ],
        },
        {
          name: "电子教材",
          children: [
            {
              fileName:
                "1.王传习《浙籍作家的城市流动与五四新文学发展关系研究》（中国社会科学出版社2019年版）_节选",
              path: 'https://lxwhfz.usx.edu.cn/static/img/xxzl/xszl/zz1.pdf',
            },
            {
              fileName: "2.专著 古大勇：多维视阈中的鲁迅",
              path: 'https://lxwhfz.usx.edu.cn/static/img/xxzl/xszl/zz2.pdf',
            },
            {
              fileName: "3.专著 古大勇：鲁迅与1990年代后中国文学和文化思潮",
              path: 'https://lxwhfz.usx.edu.cn/static/img/xxzl/xszl/zz3.pdf',
            },
          ],
        },
        {
          name: "产教融合案例",
          children: [
            {
              fileName: "产教融合案例一",
              path: 'https://lxwhfz.usx.edu.cn/static/img/xxzl/cxal/case1.pdf',
            },
            {
              fileName: "产教融合案例二",
              path: 'https://lxwhfz.usx.edu.cn/static/img/xxzl/cxal/case2.pdf',
            },
            {
              fileName: "产教融合案例三",
              path:'https://lxwhfz.usx.edu.cn/static/img/xxzl/cxal/case3.pdf',
            },
            {
              fileName: "产教融合案例四",
              path: 'https://lxwhfz.usx.edu.cn/static/img/xxzl/cxal/case4.pdf',
            },
          ],
        },
        
      ],
      other: {
        organizer: "绍兴文理学院",
        technicalSupport: "绍兴市托特科技有限公司",
        qqTxt: "实验支持与服务群",
        qq: "336940796",
      },
      isPdf: false,
    };
  },

  mounted() {
    console.log(this.$store.state.usuerdata);
    this.myswiper();
    this.getPeoNum();
  },
  created() {
    let allcout = JSON.parse(localStorage.getItem("allcounts"));
    if (allcout) {
      let indexofcout = allcout.findIndex(
        (item) => item.account == this.$store.state.usuerdata.account
      );

      if (indexofcout >= 0) {
        allcout.splice(indexofcout, 1);
        localStorage.setItem("allcounts", JSON.stringify(allcout));
      }
    }
  },
  methods: {
    level2ActiceChange(index) {
      this.level2ActiceIndex = index;
      this.levelKey = new Date();
    },
    toqq() {
      window.open(
        `http://qm.qq.com/cgi-bin/qm/qr?_wv=1027&k=XTGkl-S52sv70xQuGSvKJ8kYwEsfKRCf&authKey=Q6VjFe7lKElkrazgr53eRst6QJ2To0dLa%2FbaV5KwZR0JZb%2FoB18PME2tNtFy9W1j&noverify=0&group_code=336940796`
      );
    },
    openDoc(item) {
      console.log("🚀  openDoc  item:", item)
      if (item.path) {
        window.open(item.path);
      }
    },
    async getPeoNum() {
      let res = await proNum();
      if (res) {
        this.peonums = res;
      }
    },
    exit() {
      this.$confirm("退出登录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$store.commit("logout", "false");
          this.$router.replace("/").catch(() => {});
          localStorage.removeItem("vuex");
          this.$message({
            type: "success",
            message: "已退出登录!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    tonextss(item) {
      this.list.forEach((item) => {
        item.isactive = false;
      });
      if (item.name == "项目概况") {
        this.$refs["videoRef"].pause();
        this.$refs["videoReftwo"].pause();
        this.$refs["videoRef"].load();
        this.$refs["videoReftwo"].load();
        this.acindex = 1;
        this.list[0].isactive = true;
        this.isPdf = false;
        this.myswiper();
      }
      if (item.name == "项目介绍") {
        this.$refs["videoRef"].pause();
        this.$refs["videoReftwo"].pause();
        this.$refs["videoRef"].load();
        this.$refs["videoReftwo"].load();
        this.acindex = 2;
        this.isPdf = false;
        this.list[1].isactive = true;
      }
      if (item.name == "学习资料") {
        this.$refs["videoRef"].pause();
        this.$refs["videoReftwo"].pause();
        this.$refs["videoRef"].load();
        this.$refs["videoReftwo"].load();
        this.acindex = this.acindex;
        this.isPdf = true;
        this.list[2].isactive = true;
      }
      let now = new Date().valueOf();
      let expireTime = this.$store.state.usuerdata.expire_time - 1000 * 60 * 30;
      if (item.path && expireTime > now) {
        if (this.$store.state.usuerdata.token) {
          if (item.path == "unity") {
            // 专家
            if (this.$store.state.usuerdata.zhuanjia == 1) {
              this.$router.push({
                path: item.path,
                query: { token: this.$store.state.usuerdata.token, expert: 1 },
              });
            } else {
              // 普通
              this.$router.push({
                path: item.path,
                query: { token: this.$store.state.usuerdata.token, expert: 0 },
              });
            }
          } else {
            this.$router.push(item.path);
          }
        } else {
          this.$router.push("/");
        }
      } else {
        if (item.path == "unity" || item.path == "/my/infos") {
          this.$router.push("/");
        }
      }
    },
    login() {
      this.$router.push("/");
    },
    back() {
      this.swiperData.slidePrev();
    },
    next() {
      this.swiperData.slideNext();
    },
    myswiper() {
      setTimeout(() => {
        this.swiperData = new Swiper(".swiper-container", {
          slidesPerView: 3,
          sapceBetween: 40,
          centeredSlides: true,
          loop: true,
          autoplay: true,
        });
      }, 500);
    },
  },
};
</script>
<style  scoped>
.infosbox {
  height: 800px;
  background: url("~@/assets/infosboxbg.png");
  background-size: 100% 100%;
}

.titles-infos {
  height: 100px;
}

.pdtop {
  height: 350px;
  padding-top: 20px;
}
.titles-infos-news {
  height: 350px;
  overflow: hidden;
  font-size: 22px;
  color: #fff;
  padding-left: 200px;
  /* display: flex;
  justify-content: flex-start;
  flex-wrap: wrap; */
}
.titles-infos-news >div {
  margin-bottom: 20px;
  cursor: pointer;
  margin-right: 20px;
}
.level-2 {

}
.level-2 .item {
  width: 350px;
  position: relative;
  margin-bottom: 10px;
}
.level-2 .item .bg-3 {
  width: 350px;
  height: 50px;
}
.level-2 .item .bg {
  width: 250px;
  height: 50px;
}
.level-2 .item .ac {
  height: 20px;
  position: absolute;
  top: 43%;
  left: 30px;
  transform: translate(0, -50%);
}
.level-2 .item .name {
  position: absolute;
  top: 41%;
  left: 70px;
  transform: translate(0, -50%);
  color: black;
  font-size: 20px;
  font-weight: bold;
}

.nameMaqee {
  width: 270px;
  margin-top: 5px;
}
.items-infos {
  width: 200px;
  height: 100px;
  font-size: 22px;
  color: #fff;
  position: relative;
}

.items-infostw {
  width: 200px;
  height: 100px;
  font-size: 25px;
  color: #fff;
  position: relative;
}

.main-info {
  width: 1350px;
  height: 400px;

  margin: auto;
  margin-top: 20px;
  font-size: 17px;
  color: #fff;
}

.main-info /deep/ p {
  text-indent: 1cm;
  font-size: 18px;
}

.main-imginfo {
  width: 220px;
  height: 350px;
  margin: auto;
  margin-top: 20px;
}

.acitemindex {
  font-size: 25px;
}

.linetwo {
  width: 2px;
  height: 50px;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translate(0, -50%);
}

.bottomac {
  width: 70px;
  height: 5px;
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translate(-50%, 0);
}

.imgsbss {
  width: 50px;
  height: 100%;
  margin-left: 30px;
}

.qqqun {
  width: 160px;
  position: fixed;
  bottom: 10px;
  right: 10px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/home.vue